define('widgets/form_combobox/viewmodel',[
    "services/service.libraries",
    "i19n!i19n/strings",
    "providers/dataprovider"
],
function(librariesService, i19n, dataProvider) {

    var Widget = function (element, settings) {
    };

    Widget.prototype.activate = function (settings) {
        var self = this;
        var comboBox;
        var libraryId = null;
        var _values = null;

        self.text = ko.observable(); // the text value of the selected option - works independantly of the lookupValues collection
        self.field = settings.field;
        self.reset = settings.reset;
        self.isRefresh = settings.isRefresh;

        self.isBusy = ko.observable(false);
        self.hasFocus = ko.observable(false);
        self.hasBeenUpdated = ko.observable(false);
        self.selectOptions = ko.observableArray([]);

        self.isDirty = ko.observable(false);

        self.showUpdatedIndicator = ko.computed(function() {
            return !self.hasFocus() && !self.isDirty() && self.hasBeenUpdated();
        });

        self.errors = ko.validation.group(self.field);

        self.isValid = ko.computed(function() {
            return self.errors().length == 0;
        });

        self.isDisabled = ko.computed(function () {
            return self.isBusy() || !self.field.editable() || !self.selectOptions() || !self.selectOptions().length;
        });

        self.isDisabled.subscribe(function(newValue) {
            if (comboBox)
                comboBox.enable(!newValue);
        });

        self.reset.subscribe(function (documentInfo) {
            if (documentInfo)
                libraryId = documentInfo.libraryId;

            self.isBusy(false);
            self.selectOptions([]);
        });

        self.field.id.subscribe(function(newValue) {
            if (comboBox) {
                if (newValue == null)
                    comboBox.text('');
                else
                    comboBox.select(function(item) {
                        return item.id == newValue;
                    });
            }
        });

        self.field.value.subscribe(function(newValue) {
            self.text(newValue || "");
            if (comboBox && !comboBox.dataItem()) {
                comboBox.value(self.text());
                self.isDirty(true); // simulating isDirty to prevent "updatedIndicator" from showing.
            }
        });

        self.field.visible.subscribe(function (newValue) {
            if (!newValue)
                self.isBusy(false);
        });

        self.selectOptions.subscribe(function(newValue) {
            if (!comboBox)
                return;

            comboBox.dataSource.read();
            self.field.id.valueHasMutated();
            self.field.value.valueHasMutated();
        });
            
        // note: this subscription is added here to ensure the ko.applyBindings have been applied to the DOM first
        // to avoid a race condition where the editable subscription was firing before the view was visible, making the
        // isBusy() indicator not render in the right position in the dom.
        self.field.editable.subscribe(function (newValue) {
            self.hasBeenUpdated(false); // reset

            if (self.field.editable() === true) {
                if (libraryId === null)
                    libraryId = self.reset().libraryId;

                self.isBusy(true);

                getLookupValues(libraryId, self.field.lookup)
                .done(function (lookupValues) {
                    var options = _.map(lookupValues, function (lookupValue) {
                        return new SelectOption(lookupValue.id, lookupValue.name);
                    });
                    self.selectOptions(options);
                    if (!_.find(options, function (itm) { return itm.label == comboBox.text(); })) {

                        if (comboBox) {
                            comboBox.value(self.text());
                            settings.field.value(self.text());

                            self.field.value.valueHasMutated();
                            self.isDirty(true);
                        }
                    }
                    self.isBusy(false);
                })
                .fail(function (e) {                        
                    self.isBusy(false);

                    console.error(e);
                });

            } else {
                self.isBusy(false);
            }
        });
        self.field.editLayout = ko.observable(false);
        self.field.editLayout.focus = function () { }; //placeholder
        self.field.editLayout.isFocus = ko.observable(false);
        //self.field.editLayout.editList = function () { };

        self.attached = function (viewHtml) {
            comboBox = $("select", viewHtml).kendoComboBox({
                dataTextField: "label",
                dataValueField: "id",
                dataSource: {
                    transport: {
                        read: function (callbacks) {                                
                            callbacks.success(self.selectOptions());
                        }
                    }
                },
                filter: "startswith",
                suggest: true,
                select: onSelect,
                change: onChange
            }).data("kendoComboBox");

            // set the initial select option and the text.
            self.field.id.valueHasMutated();
            self.field.value.valueHasMutated();

            $("input.controls-is-visible:checkbox", viewHtml).change(function () {
                self.field.visible(this.checked);
            });

            $("input.k-input", viewHtml).off("keyup", "**");
            $("input.k-input", viewHtml).on("keyup", function (e) {
                if ($(this).val().length == 0) {
                    update(null);
                }

                if (e.keyCode === 13) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.cancelBubble = true;
                }
            });
        };

        function onChange() {
            // if value didn't actually change then get out of here...
            var currentText = self.text() || "";
            if (currentText == comboBox.text()) {
                self.field.value.clearError();
                return;
            }

            if (comboBox.selectedIndex == -1 && comboBox.text()) {
                self.field.value.setError(self.field.required() ? i19n.to.pleaseselectavaluefromthelist : i19n.to.thevalueenteredisinvalid);
                self.isDirty(true);
            } else {
                update(comboBox.dataItem());
            }
        }

        function onSelect(e) {
            var selectedItem = this.dataItem(e.item.index());
            update(selectedItem);
        }

        function update(selectedItem) {
            self.field.id(selectedItem ? selectedItem.id : null);
            self.field.value(selectedItem ? selectedItem.label : null);
            self.isBusy(true);
            self.hasFocus(false);
            if (self.isValid()) {
                settings.update(self.field)
                .done(function() {
                    self.hasBeenUpdated(true);
                    self.isDirty(false);
                })
                .always(function() {
                    self.isBusy(false);
                });
            } else {
                self.errors.showAllMessages();
                self.isBusy(false);
            }
        }

        function getLookupValues(libraryId, lookup) {
            var d = $.Deferred();
                
            if (_values != null && self.isBusy() && !(self.isRefresh() != undefined && self.isRefresh() == true)) {
                d.resolve(_values);
            } else {

                librariesService
                .getLookupValues(libraryId, lookup, true)
                .done(function (data) {
                    _values = _.sortBy(data, function (itm) { return itm.name; });

                    d.resolve(_values);
                })
                .fail(function (e) {
                    d.reject(e);

                    console.error(e);
                });
            }

            return d.promise();
        }
    };

    return Widget;

    function SelectOption(id, label) {
        this.id = id;
        this.label = label;
    }
});
